import { useQuery } from "@tanstack/react-query";
import { StoreReconciliationAuditsByDateModel } from "models";
import { getStoreReconciliationAuditsByDate } from "services/auditService";

export function useAuditDashboardStoreReconciliationAuditsByDate(
  storeId: string | null | undefined,
  reportDate: string | null | undefined,
  enabled = true
) {
  return useQuery<StoreReconciliationAuditsByDateModel, Error>({
    queryKey: ["audit-dashboard-reconciliation-audits-by-date", storeId, reportDate],
    queryFn: async () => {
      const audits = await getStoreReconciliationAuditsByDate(storeId!, reportDate!);
      return StoreReconciliationAuditsByDateModel.fromServerData(audits);
    },
    enabled: Boolean(enabled && storeId && reportDate),
  });
}
